const substringLength = (string, num = 20) => {
  if (!string) return null

  return string.length > num ? `${string.substring(0, num)} . . .` : string
}

export default substringLength
